// bao migrate skip
import "hasher";
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as moment from "moment";
import hasher from "hasher";

class TimelineViewModel {
    private _subs: KnockoutSubscription[] = [];
    constructor(parent) {
        this.Parent = parent;
        this.Parent.Refresh = () => { this.ParentRefresh(); };
        this._subs.push(this.IsLoading.subscribe((newVal) => {
            if (this.Parent != null && ko.isObservable(this.Parent.IsLoading)) {
                this.Parent.IsLoading(newVal);
            }
        }));
        this.OnlyShowUnread = ko.observable<boolean>();
    }
    Parent: any;
    moment = moment;
    Models = ko.observableArray([]);
    PageSize = ko.observable<number>(10);
    TotalRows = ko.observable<number>(0);
    IsLoadingBefore = ko.observable<boolean>(false);
    IsLoadingAfter = ko.observable<boolean>(false);
    IsLoading = ko.observable<boolean>();
    OnlyShowUnread: KnockoutObservable<boolean>;
    public OpenItem(item) {
        hasher.setHash(item.OpenUrl);
    }

    public OpenLink(link) {
        try {
            const url = new URL(link);
            window.open(url.href)
        } catch {
            window.open('//' + link)
        }
    }

    public LoadNextModels() {
        this.IsLoadingAfter(true);
        this.getNextModels(this.PageSize()).done(() => this.IsLoadingAfter(false));
    }
    public LoadLatestModels() {
        this.IsLoadingBefore(true);
        this.getLatestModels()
            .done(() => { this.IsLoadingBefore(false); });
    }
    /**
     *
     */
    public RefreshModels() {
        this.IsLoading(true);
        this.refreshModels()
            .done(() => { this.IsLoading(false); });
    }
    /**
     * Wird Parent.Refresh zugewiesen...
     * Modul wird neu geladen. Ergebnisliste wird zurückgsetzt
     *
     */
    private ParentRefresh() {
        this.IsLoadingAfter(false);
        this.IsLoadingBefore(false);
        this.IsLoading(true);
        this.Models([]);
        this.TotalRows(0);
        this.getModels(this.PageSize()).done(() => {
            this.IsLoading(false);
        });
    }
    ;
    /**
     * holt die neuesten ab
     */
    private getLatestModels() {
        return Bao.post("Timeline/GetLatest", JSON.stringify({
            lastLatestId: this.Models.peek()[0].Id
        })).done((data) => {
            this.Models(data.models.concat(this.Models()));
        });
    }
    ;
    /**
     * holt die nächsten ab
     */
    private getNextModels(pageSize) {
        var models = this.Models();
        return Bao.post("Timeline/GetNext", JSON.stringify({
            lastId: models[models.length - 1].Id,
            pageSize: pageSize,
            onlyShowUnread: this.OnlyShowUnread()
        })).done((data) => {
            this.Models(this.Models().concat(data.models));
            this.TotalRows(data.total);
        });
    }
    ;
    /**
     * holt initial ab
     */
    private getModels(pageSize) {
        return Bao.post("Timeline/GetInitial", JSON.stringify({
            pageSize: pageSize,
            onlyShowUnread: this.OnlyShowUnread()
        })).done((data) => {
            this.Models(this.Models().concat(data.models));
            this.TotalRows(data.total);
        });
    }
    ;
    /**
     * aktualisiert die vorhandenen
     */
    private refreshModels() {
        var guids = [];
        var models = ko.unwrap(this.Models);
        for (var i in models) {
            guids.push(models[i].Id);
        }
        return Bao.post("Timeline/GetByIds", JSON.stringify({
            ids: guids
        })).done((data) => {
            this.Models(data.models);
            this.TotalRows(data.total);
        });
    }
    ;
    private loadUserProfile() {
        return Bao.post("Timeline/GetUserProfile", JSON.stringify({})).then((data) => {
            this.OnlyShowUnread(data.onlyShowUnread === "true" ? true : false);
        });
    }
    public init() {
        this.IsLoading(true);
        return this.loadUserProfile()
            .then(() => {
            return this.getModels(this.PageSize());
        });
    }
    ;
    public loaded() {
        this.IsLoading(false);
        this.OnlyShowUnread.subscribe(() => {
            this.ParentRefresh();
        });
    }
    ;
}
export default TimelineViewModel;